import ActionsForm from '@/shared/mixins/actionsForm'
import qmaTemplateGuidance from '@/shared/http/repositories/business/qmaTemplateGuidance'
import ImageNotFound from '../../../../../../../../../static/img/qma/semDados.svg'
import IconImagem from '../../../../../../../../../static/img/qma/IconImagem.svg'
import deleteQuestion from '../TemplateDetail/deleteQuestion/deleteQuestion.vue'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  name: 'signatureTemplate',
  props: ['templateid', 'novosItensTableOrientacao', 'editarItensTableOrientacao'],
  components: {deleteQuestion},
  mixins: [ActionsForm],
  data () {
    return {
      dataTemplateQMAOrientacao: [],
      dataEdicoesCancelar: [],
      dataItensChecadoEdicoesCancelar: [],
      iconImg: IconImagem,
      dataEdicoesInativoCancelar: [],
      dataEdicoesAtivoCancelar: [],
      liberaExclusaoEdicao: false,
      notFound: ImageNotFound
    }
  },
  watch: {
    novosItensTableOrientacao (value) {
      this.dataTemplateQMAOrientacao.push(...value)
    },
    editarItensTableOrientacao (value) {
      this.EditaOrientacao(value)
    }
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    popUpExcluir (value) {
      this.$refs.modal_Excluir_Orientacao.popUptOrientacao(value.id)
    },
    addorientacao () {
      this.$emit('popUpOrientacao', true)
    },
    Editarorientacao (id, nivel) {
      var popUpEditar = {
        id: id,
        nivel: nivel
      }
      this.$emit('popUpOrientacaoEditar', popUpEditar)
    },
    onLoad () {
      loading.push()
      qmaTemplateGuidance.GetQMATemplateListaOrientacao(this.templateid)
        .then((Response) => {
          loading.pop()
          this.dataTemplateQMAOrientacao = Response.data.data
        })
    },
    CheckboxAtivacaoInativacao (id, status) {
      if (status !== 1) {
        this.AtivacaoInativacao('AG. ENVIO - ATIVAÇÃO', false, true, id, 'rgb(28, 98, 40)', 'rgb(203, 233, 207)')
      } else {
        this.AtivacaoInativacao('AG. ENVIO - INATIVAÇÃO', true, false, id, 'rgb(136, 22, 22)', 'rgb(255, 205, 205)')
      }
    },
    EditaOrientacao (value) {
      for (let i = 0; i < this.dataTemplateQMAOrientacao.length; i++) {
        if (this.dataTemplateQMAOrientacao[i].id === value.templateOrientacaoId) {
          this.dataTemplateQMAOrientacao[i].edicao = true
          this.dataTemplateQMAOrientacao[i].descricaoEdicao = 'AG. ENVIO - EDITAR NÍVEL PRIORIDADE'
          this.dataTemplateQMAOrientacao[i].colorStatus = 'rgb(255, 216, 187)'
          this.dataTemplateQMAOrientacao[i].colorFonte = 'rgb(188, 72, 7)'
        }
      }
    },
    deleteOrientacao (value) {
      for (let i = 0; i < this.dataTemplateQMAOrientacao.length; i++) {
        if (this.dataTemplateQMAOrientacao[i].id === value.templateOrientacaoId) {
          this.dataTemplateQMAOrientacao[i].excluir = true
          this.dataTemplateQMAOrientacao[i].edicao = true
          this.dataTemplateQMAOrientacao[i].descricaoEdicao = 'AG. ENVIO - EXCLUIR'
          this.dataTemplateQMAOrientacao[i].colorStatus = 'rgb(255, 216, 187)'
          this.dataTemplateQMAOrientacao[i].colorFonte = 'rgb(188, 72, 7)'
          this.$emit('EditaOrientacao', value)
        }
      }
    },
    removerdeleteOrientacao (value) {
      for (let i = 0; i < this.dataTemplateQMAOrientacao.length; i++) {
        if (this.dataTemplateQMAOrientacao[i].id === value) {
          this.dataTemplateQMAOrientacao[i].excluir = false
          this.dataTemplateQMAOrientacao[i].edicao = false
          this.dataTemplateQMAOrientacao[i].descricaoEdicao = ''
          this.dataTemplateQMAOrientacao[i].colorStatus = ''
          this.dataTemplateQMAOrientacao[i].colorFonte = ''
          this.$emit('removerdeleteOrientacao', value)
        }
      }
    },
    AtivacaoInativacao (descricao, inativacao, ativacao, id, fonte, status) {
      for (let i = 0; i < this.dataTemplateQMAOrientacao.length; i++) {
        if (this.dataTemplateQMAOrientacao[i].id === id) {
          this.dataTemplateQMAOrientacao[i].edicao = true
          this.dataTemplateQMAOrientacao[i].status = inativacao === true ? 0 : 1
          this.dataTemplateQMAOrientacao[i].descricaoEdicao = descricao
          this.dataTemplateQMAOrientacao[i].colorStatus = status
          this.dataTemplateQMAOrientacao[i].ativo = ativacao
          this.dataTemplateQMAOrientacao[i].inativo = inativacao
          this.dataTemplateQMAOrientacao[i].colorFonte = fonte
          if (ativacao === true) {
            this.$emit('addEdicaoAtivacaoOrientacao', id)
          }
          if (inativacao === true) {
            this.$emit('addEdicaoInativacaoOrientacao', id)
          }
        }
      }
    },
    CheckExclusaoEdicao (id, value) {
      for (let i = 0; i < this.dataTemplateQMAOrientacao.length; i++) {
        if (this.dataTemplateQMAOrientacao[i].id === id) {
          this.dataTemplateQMAOrientacao[i].check = value
        }
      }
    },

    verificaCamposCheck () {
      let existeCheckTrue = this.dataTemplateQMAOrientacao.some(item => item.check === true)

      if (existeCheckTrue === false) {
        this.liberaExclusaoEdicao = false
      } else {
        this.liberaExclusaoEdicao = true
      }
      this.$emit('liberaButonEdicaoExclusao', this.liberaExclusaoEdicao)
    },
    AdicionarItenParaExclusaoDaEdicao (id) {
      this.Adicionar = !this.Adicionar
      var div = document.getElementById(id.id)
      // Verifica se a classe 'clicked' já está presente na div
      var isClicked = div.classList.contains('clicked')
      // Se já estiver clicada, remove a classe, caso contrário, adiciona
      if (isClicked) {
        div.classList.remove('clicked')
        this.dataEdicoesCancelar = this.dataEdicoesCancelar.filter(item => item !== id.id)
        this.dataItensChecadoEdicoesCancelar = this.dataItensChecadoEdicoesCancelar.filter(item => item !== id.id)

        this.CheckExclusaoEdicao(id.id, false)
        this.verificaCamposCheck()
      } else {
        div.classList.add('clicked')

        if (id.add === true) {
          if (this.dataEdicoesCancelar !== null && this.dataEdicoesCancelar !== undefined && this.dataEdicoesCancelar.length > 0) {
            this.dataEdicoesCancelar.push(id.id)
            this.dataItensChecadoEdicoesCancelar.push(id.id)
          } else {
            this.dataEdicoesCancelar[0] = id.id
            this.dataItensChecadoEdicoesCancelar[0] = id.id
          }
        }

        if (id.inativo === true) {
          if (this.dataEdicoesInativoCancelar !== null && this.dataEdicoesInativoCancelar !== undefined && this.dataEdicoesInativoCancelar.length > 0) {
            this.dataEdicoesInativoCancelar.push(id.id)
          } else {
            this.dataEdicoesInativoCancelar[0] = id.id
          }
        }

        if (id.ativo === true) {
          if (this.dataEdicoesAtivoCancelar !== null && this.dataEdicoesAtivoCancelar !== undefined && this.dataEdicoesAtivoCancelar.length > 0) {
            this.dataEdicoesAtivoCancelar.push(id.id)
          } else {
            this.dataEdicoesAtivoCancelar[0] = id.id
          }
        }

        this.CheckExclusaoEdicao(id.id, true)
        this.verificaCamposCheck()
      }
    },
    removerItemTable () {
      for (let i = 0; i < this.dataEdicoesCancelar.length; i++) {
        let idCancelar = this.dataEdicoesCancelar[i]

        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.dataTemplateQMAOrientacao.length; j++) {
          if (this.dataTemplateQMAOrientacao[j].id === idCancelar) {
            this.dataTemplateQMAOrientacao.splice(j, 1)
            j--
            this.verificaCamposCheck()
            break
          }
        }
      }
      this.dataEdicoesCancelar = []
    },
    removerEdicoesInativacaoTable () {
      for (let i = 0; i < this.dataEdicoesInativoCancelar.length; i++) {
        let idCancelarInativacao = this.dataEdicoesInativoCancelar[i]
        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.dataTemplateQMAOrientacao.length; j++) {
          if (this.dataTemplateQMAOrientacao[j].id === idCancelarInativacao) {
            this.dataTemplateQMAOrientacao[j].status = 1
            this.dataTemplateQMAOrientacao[j].descricaoEdicao = ''
            this.dataTemplateQMAOrientacao[j].inativo = false
            this.dataTemplateQMAOrientacao[j].edicao = false
            this.dataTemplateQMAOrientacao[j].check = false
            this.verificaCamposCheck()
            break
          }
        }
      }
    },
    removerEdicoesAtivacaoTable () {
      for (let i = 0; i < this.dataEdicoesAtivoCancelar.length; i++) {
        let idCancelarInativacao = this.dataEdicoesAtivoCancelar[i]
        // Encontra o índice do objeto a ser removido
        for (let j = 0; j < this.dataTemplateQMAOrientacao.length; j++) {
          if (this.dataTemplateQMAOrientacao[j].id === idCancelarInativacao) {
            this.dataTemplateQMAOrientacao[j].status = 0
            this.dataTemplateQMAOrientacao[j].descricaoEdicao = ''
            this.dataTemplateQMAOrientacao[j].inativo = false
            this.dataTemplateQMAOrientacao[j].edicao = false
            this.dataTemplateQMAOrientacao[j].check = false
            this.verificaCamposCheck()
            break
          }
        }
      }
    },
    limparItensEdicao () {
      if (this.dataItensChecadoEdicoesCancelar.length > 0) {
        this.$emit('removerItensparaEdicaoExclusaoOrientacao', this.dataItensChecadoEdicoesCancelar)
      }
      // if (this.dataEdicoesAtivoCancelar.length > 0) {
      //   this.$emit('removerItensparaEdicaoAtivacaoOrientacaoExclusao', this.dataEdicoesAtivoCancelar)
      // }
      // if (this.dataEdicoesInativoCancelar.length > 0) {
      //   this.$emit('removerItensparaEdicaoInativacaoOrientacaoExclusao', this.dataEdicoesInativoCancelar)
      // }
    },
    downloadOrientacaoImagem (url, nome) {
      loading.push()

      qmaTemplateGuidance.DownloadOrientacaoTemplate({url: url})
        .then((Response) => {
          loading.pop()
          var src = Response.data
          this.abrirImagem(src, nome)
        })
        .catch((Error) => {
          loading.pop()
          toast.warning('Imagem não localizada')
        })
    },
    abrirImagem (src, alt) {
      var modal = document.getElementById('myModal')

      var modalImg = document.getElementById('img01')
      var captionText = document.getElementById('caption')

      modal.style.display = 'block'
      modalImg.src = 'data:image/jpeg;base64,' + src
      captionText.innerHTML = alt
    },
    fecharModal () {
      var modal = document.getElementById('myModal')
      modal.style.display = 'none'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/guidanceTemplate/guidanceTemplate.js